import React from 'react';
import { Box, Typography } from '@mui/material';

const FavouriteHeader = ({cart__items}) => {
  return (
    <>
        <Box>
            <Typography variant='h3' sx={{color:'rgba(86, 4, 246, 1)', my:2, fontSize:{xs:'1.5rem', md:'3rem',fontFamily: theme=> theme.typography.bigText,}}}>
                My Favorites
            </Typography>
            <Typography sx={{my:2, color:'rgba(18, 18, 18, 0.8)',fontFamily: theme=> theme.typography.smallText,}}>
                Track your purchases and enjoy fast delivery across Nigeria. Mydarads is here for you.
            </Typography>
        </Box>
        <Box sx={{display:'flex', gap:2, justifyContent:{xs:'space-between', md:'start',fontFamily: theme=> theme.typography.smallText,}}}>
            <Typography>Buy Later Items</Typography>
            <Typography sx={{backgroundColor:'rgba(246, 167, 4, 1)', px:1, fontWeight:600, borderRadius:'4px'}}>{cart__items?.length}</Typography>
        </Box>
    </>
  )
}

export default FavouriteHeader